import { processItems } from './helpers/processItems';

const phoneTypeKind = {
	WORK: 'Рабочий',
	PERSONAl: 'Личный',
	// ... Todo: add more if needed
};

const emptyContact = {
	id: 'empty-contacts',
	label: 'Нет контактов',
};

export const companySideAreaContacts = (company) => {
	const { activeItems: activeNumbers, disabledItems: disabledNumbers } =
		processItems({
			array: company.personalContacts,
			checkActive: (item) => !item.isDeleted,
		});

	const {
		activeItems: activeGeneralNumbers,
		disabledItems: disabledGeneralNumbers,
	} = processItems({
		array: company.generalNumbers,
		checkActive: (item) => item.active,
	});

	const items = [
		{
			id: 'contacts-list-1',
			plate: {
				collapseLabel: `Больше не работают (${disabledNumbers.length})`,
			},
			data: {
				contacts: activeNumbers.map((item) => ({
					id: item.id,
					phones: (item.numbers ?? [])
						.filter((phone) => !phone.isDeleted)
						.map(({ number, kind }) => ({
							phone: number,
							type: phoneTypeKind[kind],
							id: number,
						})),
					desc: item.comment,
					label: [item.lastName, item.firstName, item.middleName]
						.filter(Boolean)
						.join(' '),
					role: item.position,
				})),
			},
			dataExtra: disabledNumbers.length
				? {
					contacts: disabledNumbers.map((item) => ({
						id: item.id,
						phone: item.number,
						desc: item.comment,
					})),
				}
				: null,
		},
		{
			id: 'contacts-list-2',
			plate: {
				collapseLabel: `Больше не работают (${disabledGeneralNumbers.length})`,
			},
			data: {
				contacts: activeGeneralNumbers.map((item) => ({
					id: item.id,
					phone: item.number,
					desc: item.comment,
				})),
			},
			dataExtra: disabledGeneralNumbers.length
				? {
					contacts: disabledGeneralNumbers.map((item) => ({
						id: item.id,
						phone: item.number,
						desc: item.comment,
					})),
				}
				: null,
		},
	].filter((item) => item.data.contacts.length || item.dataExtra);

	return {
		id: 'contacts',
		label: 'Контакты',
		items: items.length
			? items
			: [
				{
					id: 'contacts-list-empty',
					data: {
						contacts: [emptyContact],
					},
				},
			],
	};
};
